module.exports = __webpack_public_path__ + "img/icon_comment.8080997f.svg";